<template>
    <mslPage :aIndex="1">
        <template v-slot:mslBody>

                <div class="sort">
                    <!-- banner -->
                    <div class="banner">
                        <div style="height: 74px; width: 100%;"></div>
                        <div class="center m_center banner_center flex flex-dir-top flex-cross-top flex-main-center">
                            <div class="b_title" v-if="baseInfo.product_banner && baseInfo.product_banner.id">{{ baseInfo.product_banner.title }}</div>
                            <div class="b_intro" v-if="baseInfo.product_banner && baseInfo.product_banner.id" v-html="baseInfo.product_banner.content"></div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="center m_center">
                            <!-- 产品分类 -->
                            <div class="sort_menu space_center">
                                <div>
                                    <el-select v-model="value" placeholder="请选择" @visible-change="showPopup" :loading="isSelect" @change="getSortProList">
                                        <el-option
                                                v-for="item in cateogry"
                                                :key="item.id"
                                                :label="item.cate_name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="total">一共{{ len }}件商品</div>
                            </div>
                            <!-- 列表 -->
                            <el-row v-loading="loading">
                                <div class="list flex flex-dir-left flex-wrap" v-if="list && list.length > 0">
                                    <router-link :to="{ name: 'production_detail', query: { id: item.id } }" v-for="(item, index) in list" :key="index" class="td_none item pointer">
                                        <div class="">
                                            <div class="img_box">
                                                <img :src="item.image" alt="" class="pro_img" v-if="item.image">
                                                <img src="../assets/pc_pic/new/no_data.png" alt="" v-else>
                                            </div>
                                            <div class="li_content">
                                                <div class="title w d_ellipsis ta_center">{{ item.store_name }}</div>
                                                <div class="price w d_ellipsis ta_center">{{ '￥' + item.price }}</div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <noData v-if="list && list.length == 0 && !loading"></noData>
                            </el-row>
                            <!-- 分页 -->
                            <div class="page row_center">
                                <el-pagination
                                        :page-size="9"
                                        :pager-count="5"
                                        layout="prev, pager, next"
                                        :total="len"
                                        @current-change="getCurrentPage"
                                        hide-on-single-page>
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>

        </template>
    </mslPage>
</template>
<script>
    import { proList, proSort, baseInfo } from '../api/common.js'
    import noData from '../components/no_data'
    export default {
        name: "production_2",
        components: {
            noData
        },
        data () {
            return {
                img: '',
                currentPage: 1,
                baseInfo: {},
                list: [],
                formData: {
                    page: 1,
                    limit: 9,
                    cate_id: null
                },
                len: null,
                loading: false,
                cateogry: [],
                isSelect: true,
                value: ''
            }
        },
        mounted() {
            // this.getProSort();
            this.getList(1);
            this.getBaseInfo();
        },
        methods: {
            getBaseInfo () {
                try {
                    baseInfo().then(res => {
                        if(res.code == 1) {
                            this.baseInfo = res.data;
                            console.log(this.baseInfo);
                        }
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新')
                }
            },
            showPopup (e) {
                console.log(e, 'e');
                let isSort = e;
                if (isSort) this.getProSort();
            },
            getCurrentPage (e) {
                this.currentPage = e;
                this.getList(this.currentPage);
                window.scrollTo(0, 0);//回到顶部
            },
            getProSort () {
                try {
                    proSort().then(res => {
                        console.log(res, '产品分类');
                        if (res.code == 1) {
                            this.cateogry = res.data.cateogry
                            this.cateogry.unshift({
                                cate_name: '全部',
                                cate_id: null
                            })
                        }
                        this.isSelect = false;
                        console.log(this.isSelect, 'isSelect');
                    })
                } catch {
                    this.isSelect = false;
                    this.$message.error('加载数据失败，请刷新');
                }
            },
            getSortProList (e) {
                this.formData.cate_id = e;
                this.getList(1);
            },
            async getList (page) {
                try {
                    let len = this.len;
                    let list = this.list;
                    this.formData.page = page;
                    let data = {
                        ...this.formData
                    }
                    this.loading = true;
                    let res = await proList(data);
                    if (res.code == 1) {
                        list = res.data.list;
                        len = Number(res.data.total);
                        this.list = list;
                        this.len = len;
                        this.loading = false;
                    }
                } catch {
                    this.loading = false;
                    this.$message.error('加载数据失败，请刷新');
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .sort {
        /* banner */
        .banner {
            width: 100%;
            height: 365px;
            background: #fafafa url("../assets/pc_pic/pro_sort/bg.png") no-repeat center center;
            background-size: cover;
            .banner_center {
                height: 290px;
                .b_title {
                    font-size: 46px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    line-height: 54px;
                    color: #333333;
                }
                .b_intro {
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 24px;
                    color: #8C8C8C;
                    margin-top: 16px;
                    &::v-deep {
                        p {
                            margin-top: 0!important;
                            margin-bottom: 0!important;
                        }
                    }
                }
            }
        }
        /* 产品分类 */
        .content {
            padding: 48px 0;
            .ml_24 {
                margin-left: 24px;
            }
            .sort_menu {
                .total {
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 24px;
                    color: #8C8C8C;
                    opacity: 0.8;
                    margin-right: 1px;
                }
            }
            .list {
                margin-top: 48px;
                width: 100%;
                min-width: 1250px;
                .item {
                    width: 31.64%;
                    height: 494px;
                    margin-right: 2.539%;
                    margin-bottom: 33px;
                    background-color: #FAFAFA;
                    padding: 35px;
                    box-sizing: border-box;
                    &:nth-child(3n){
                        margin-right: 0;
                    }
                    /*.pro_img {*/
                    /*    width: 336px;*/
                    /*    height: 336px;*/
                    /*    border-radius: 4px;*/
                    /*}*/
                    &:hover {
                        img {
                            transform: scale(1.05);
                            transition: all 0.6s;
                        }
                    }
                    .img_box {
                        width: 336px;
                        height:336px;
                        border-radius: 4px;
                        overflow: hidden;
                        &:hover {
                            .mask {
                                background-color: rgba(255, 255, 255, .8);
                                .buy_btn {
                                    display: flex;

                                    &:hover {
                                        background-color: #262626;
                                        color: #fff;
                                    }
                                }
                            }
                            /*img {*/
                            /*    transform: scale(1.05);*/
                            /*    transition: all 0.6s;*/
                            /*}*/
                        }

                        img {
                            width: 100%;
                            height: 100%;
                            transition: all 0.6s;
                        }
                    }
                    .li_content {
                        width: 100%;
                        margin-top: 16px;
                        .title {
                            font-size: 20px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            line-height: 28px;
                            color: #262626;
                        }
                        .price {
                            margin-top: 12px;
                            font-size: 16px;
                            font-family: Microsoft YaHei;
                            font-weight: bold;
                            line-height: 28px;
                            color: #262626;
                        }
                    }
                }
            }
            .page {
                margin-top: 16px;
            }
        }
    }

</style>
